import { Login, LoginForm } from "react-admin";
import { useState } from "react";
import firebase from "firebase/compat/app"

import "./CustomLoginPagev2.css"
const CustomLoginForm = (props) => (
    <div>
        <LoginForm {...props} />
    </div>
);

const customMessage = (name) => {
    if (name.includes("tarik")) {
        return "Merci de ne pas télécharger de la donnée depuis l'espace admin"
    }
    else if (name.includes("ikram")) {
        return "une question"
    }
    else if (name.includes("malik")) {
        return "Big BOSS"
    }
    else {
        return "Merci de me contacter pour personnaliser votre message d'accueil"
    }
}
const CustomLoginPage = (props) => {
    const [email, setEmail] = useState("")
    const [pass, setPass] = useState("")
    const [loading, setLoading] = useState(false)
    const login = () => {
        if (!email) {
            alert("Remplir l'email")
            return;
        }
        if (!pass) {
            alert("Remplir le mdp")
            return;
        }
        setLoading(true)
        firebase.auth().signInWithEmailAndPassword(
            email,
            pass
        )
            .then(res => {
                //
                setLoading(false)

            })
            .catch(err => {
                setLoading(false)
                alert("Vérifez l'email et mdp")

            })
    }

    return (
        <div className="container">
            <div className="inner">
                <form onSubmit={() => { }} className="form--container">
                    <div className="form--inner">
                        <div className="input-container">
                            <div className="input-inner">
                                <input type="text" id="email" value={email} label="Email" onChange={(e) => { setEmail(e.target.value) }} />
                            </div>
                        </div>
                        <div className="input-container">
                            <div className="input-inner">
                                <input type="password" id="password" value={pass} label="password" onChange={(e) => { setPass(e.target.value) }} />
                            </div>
                        </div>

                        <div className="button-container">
                            <div className="button-inner">
                                {loading ? (
                                    <button type="password" id="password" label="password" onClick={(e) => {
                                        e.preventDefault();

                                    }}>
                                        <i class="fas fa-circle-notch fa-spin"></i>
                                    </button>

                                ) : (<button type="password" id="password" label="password" onClick={(e) => {
                                    e.preventDefault();
                                    login()
                                }}>
                                    GO
                                </button>
                                )}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}


export default CustomLoginPage;
